import { useMutation } from "react-query";
import overwriteName from "../services/overwriteName";

function useOverwriteName() {
  return useMutation(["overwrite-name"], overwriteName);
}

export default useOverwriteName;
